import React from 'react';

/**
 * Safe useId usage which can be used for DOM elements id
 * @returns {string}
 */
export function useSafeId() {
  return React.useId().replace(/[_\W]/g, '');
}
